<div class="profile-container">
    <div class="">
        <div class="profile-content">
            <div class="personal-details">
                <div class="header-block">
                    <div class="header-title">
                        <app-breadcrumb></app-breadcrumb>
                    </div>
                    <div class="add-block">
                        <div class="search">
                            <form autocomplete="off">
                                <input type="text" (keyup.enter)="search()" [ngModelOptions]="{standalone: true}"
                                    [(ngModel)]="searchFilter" placeholder="search">
                            </form>
                            <i class="bi bi-search" (click)="search()"></i>
                        </div>
                        <button class="add-ticket" title="Add" (click)="clearData()" data-toggle="modal" data-target="#addTemplate"><i
                                class="bi bi-plus-lg"></i> {{ 'generic.add' | translate }}</button>
                        <div class="filter-icon">
                            <i class="bi bi-arrow-clockwise" title="Refresh" (click)="refreshAll()"></i>
                        </div>
                    </div>
                </div>

                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width: 30%;">{{ 'object-template.name' | translate }}</th>
                            <th style="width: 25%;">{{ 'object-template.type' | translate }}</th>
                            <th style="width: 25%;">{{ 'object-template.group' | translate }}</th>
                            <th style="width: 20%;text-align: center;padding: 0;" class="">{{ 'generic.action' |
                                translate }}</th>
                        </tr>
                    </thead>
                </table>
                <div *ngIf="!isLoading">
                    <div class="data-view" id="{{template.id}}"
                        [ngClass]="{ 'delete-highlight': template.objectTemplateId == recordId }" *ngFor="let template of objectTemplateList | paginate : {
                        itemsPerPage: tableSize,
                            currentPage: pageNo,
                            totalItems: count
                        }  ;let i = index">

                        <p style="width: 30%;">{{template.name}}</p>
                        <p style="width: 25%;padding-left: 25px">{{template.type}}</p>
                        <p style="width: 25%;padding-left: 25px">{{template.group}}</p>

                        <p class="action-buttons" style="width: 20%;padding-left: 25px;">
                            <i (click)="getObjectTemplateById(template.objectTemplateId)" data-toggle="modal"
                                title="View" data-target="#viewRole" class="bi bi-eye-fill"></i>
                            <!-- <i class="bi bi-pencil-square" (click)="getObjectTemplateById(template.objectTemplateId)" title="Edit" data-toggle="modal" data-target="#editModal" ></i> -->
                            <i (click)="cloneTemplate(template.objectTemplateId)" class="bi bi-copy"
                                title="Clone" data-toggle="modal" data-target="#addTemplate"></i>
                            <i (click)="selectDelete(template.id,template)" class="bi bi-trash" data-toggle="modal"
                                title="Delete" data-target="#deleteModal"></i>
                        </p>
                    </div>
                </div>


                <div class="loader" *ngIf="isLoading">
                    <div class="spinner"></div>
                </div>

                <div class="loader" *ngIf="!isLoading && objectTemplateList.length == 0">
                    <div class="no-data">
                        <img src="assets/no-data-6.png" alt="">
                        <p>no data found</p>
                    </div>

                </div>

                <div class="paginator">
                    <p-paginator #paginator (onPageChange)="onTableDataChange($event)" [first]="first"
                        [rows]="recordsPerPage" [totalRecords]="count" [showFirstLastIcon]="true"
                        [showCurrentPageReport]="true" [showPageLinks]="true" [showJumpToPageDropdown]="false"
                        currentPageReportTemplate="{first} - {last} of {totalRecords}">
                    </p-paginator>
                </div>


            </div>
        </div>
    </div>
</div>


<div class="modal fade" id="addTemplate" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">{{ 'object-template.headings.add' | translate }}
                    <span data-dismiss="modal" (click)="closeModal()">
                        <i class="bi bi-x-lg"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <div [formGroup]="objectForm">
                    <div class="form-group common-fields">
                        <div class="row">
                            <div class="col-md-12 col-lg-12">
                                <label>{{ 'object-template.name' | translate }} <span class="required">*</span></label>
                                <input formControlName="name" type="text" class="form-control">
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <label>{{ 'object-template.group' | translate }} <span class="required">*</span></label>
                                <select class="form-control" formControlName="group">
                                    <option value="" selected disabled> -- Select Group --</option>
                                    <option value="{{object.groupName}}"
                                        *ngFor="let object of objectGroupData;let i = index">{{object.groupName}}
                                    </option>
                                </select>
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <label>{{ 'object-template.type' | translate }} <span class="required">*</span></label>
                                <select class="form-control" formControlName="type">
                                    <option value="" selected disabled> -- Select Type --</option>
                                    <option value="{{object.typeName}}"
                                        *ngFor="let object of objectTypeData;let i = index">{{object.typeName}}</option>
                                </select>
                            </div>
                            <!-- <div class="col-md-12 col-lg-12 check-box">
                                <p><input type="checkbox" [ngModelOptions]="{standalone: true}" [checked]="branch" [(ngModel)]="branch"> {{ 'object-template.branch' | translate }}</p>
                                <p><input type="checkbox" [ngModelOptions]="{standalone: true}" [checked]="department" [(ngModel)]="department"> {{ 'object-template.department' | translate }}</p>
                                <p><input type="checkbox" [ngModelOptions]="{standalone: true}" [checked]="location" [(ngModel)]="location"> {{ 'object-template.location' | translate }}</p>
                                <p><input type="checkbox" [ngModelOptions]="{standalone: true}" [checked]="make" [(ngModel)]="make"> {{ 'object-template.make' | translate }}</p>
                                <p><input type="checkbox" [ngModelOptions]="{standalone: true}" [checked]="model" [(ngModel)]="model"> {{ 'object-template.model' | translate }}</p>
                                <p><input type="checkbox" [ngModelOptions]="{standalone: true}" [checked]="serialNumber" [(ngModel)]="serialNumber"> {{ 'object-template.serialNumber' | translate }}</p>
                                <p><input type="checkbox" [ngModelOptions]="{standalone: true}" [checked]="originalCost" [(ngModel)]="originalCost"> {{ 'object-template.originalCost' | translate }}</p>
                                <p><input type="checkbox" [ngModelOptions]="{standalone: true}" [checked]="currentCost" [(ngModel)]="currentCost"> {{ 'object-template.currentCost' | translate }}</p>
                                <p><input type="checkbox" [ngModelOptions]="{standalone: true}" [checked]="depreciationRequired" [(ngModel)]="depreciationRequired"> {{ 'object-template.depreciationRequired' | translate }}</p>
                                <p><input type="checkbox" [ngModelOptions]="{standalone: true}" [checked]="warranty" [(ngModel)]="warranty"> {{ 'object-template.warranty' | translate }}</p>
                                <p><input type="checkbox" [ngModelOptions]="{standalone: true}" [checked]="purchase" [(ngModel)]="purchase"> {{ 'object-template.purchase' | translate }}</p>
                                <p><input type="checkbox" [ngModelOptions]="{standalone: true}" [checked]="parentAssetIdFlag" [(ngModel)]="parentAssetIdFlag"> {{ 'object-template.parentAssetIdFlag' | translate }}</p>
                                <p><input type="checkbox" [ngModelOptions]="{standalone: true}" [checked]="quantity" [(ngModel)]="quantity"> {{ 'object-template.quantity' | translate }}</p>
                                <p><input type="checkbox" [ngModelOptions]="{standalone: true}" [checked]="deploy" [(ngModel)]="deploy"> {{ 'object-template.deploy' | translate }}</p>
                            </div> -->
                            <div class="col-md-12 col-lg-12" style="margin-top: 15px;">
                                <!-- <div class="status-table">
                                    <table class="table table table-striped">
                                        <thead>
                                            <tr>
                                                <th style="width: 35%;padding-left: 10px;">
                                                    <input type="checkbox" (click)="allCheck($event)" [ngModelOptions]="{standalone: true}" [(ngModel)]="isAllChecked">
                                                    Name</th>
                                                <th style="width: 65%;text-align: end;">Description</th>
                                            </tr>
                                        </thead>

                                        <tbody>

                                            <tr>
                                                <td>
                                                    <input type="checkbox" (change)="updateMasterCheckbox()" [ngModelOptions]="{standalone: true}" [(ngModel)]="branch">
                                                    {{ 'object-template.branch' | translate }}
                                                </td>
                                                <td style="text-align: end;">The office/division where the asset belongs; can be added to identify ownership.</td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <input type="checkbox" (change)="updateMasterCheckbox()" [ngModelOptions]="{standalone: true}" [(ngModel)]="department">
                                                    {{ 'object-template.department' | translate }}
                                                </td>
                                                <td style="text-align: end;">The team or function using the asset; addable for tracking usage.</td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <input type="checkbox" (change)="updateMasterCheckbox()" [ngModelOptions]="{standalone: true}" [(ngModel)]="location">
                                                    {{ 'object-template.location' | translate }}
                                                </td>
                                                <td style="text-align: end;">The physical place where the asset is kept; must be added for easy identification.</td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <input type="checkbox" (change)="updateMasterCheckbox()" [ngModelOptions]="{standalone: true}" [(ngModel)]="make">
                                                    {{ 'object-template.make' | translate }}
                                                </td>
                                                <td style="text-align: end;">The manufacturer or brand of the asset; addable to know who produced it.</td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <input type="checkbox" (change)="updateMasterCheckbox()" [ngModelOptions]="{standalone: true}" [(ngModel)]="model">
                                                    {{ 'object-template.model' | translate }}
                                                </td>
                                                <td style="text-align: end;">The version or design name of the asset; addable to distinguish similar items.</td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <input type="checkbox" (change)="updateMasterCheckbox()" [ngModelOptions]="{standalone: true}" [(ngModel)]="serialNumber">
                                                    {{ 'object-template.serialNumber' | translate }}
                                                </td>
                                                <td style="text-align: end;">The unique code given by the manufacturer; must be added to uniquely identify the asset.</td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <input type="checkbox" (change)="updateMasterCheckbox()" [ngModelOptions]="{standalone: true}" [(ngModel)]="originalCost">
                                                    {{ 'object-template.originalCost' | translate }}
                                                </td>
                                                <td style="text-align: end;">The price paid when the asset was first purchased; addable for financial records.</td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <input type="checkbox" (change)="updateMasterCheckbox()" [ngModelOptions]="{standalone: true}" [(ngModel)]="currentCost">
                                                    {{ 'object-template.currentCost' | translate }}
                                                </td>
                                                <td style="text-align: end;">The present value of the asset; addable to reflect today’s worth.</td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <input type="checkbox" (change)="updateMasterCheckbox()" [ngModelOptions]="{standalone: true}" [(ngModel)]="depreciationRequired">
                                                    {{ 'object-template.depreciationRequired' | translate }}
                                                </td>
                                                <td style="text-align: end;">The reduction in value over time; addable to calculate financial reporting.</td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <input type="checkbox" (change)="updateMasterCheckbox()" [ngModelOptions]="{standalone: true}" [(ngModel)]="warranty">
                                                    {{ 'object-template.warranty' | translate }}
                                                </td>
                                                <td style="text-align: end;">The validity period of manufacturer support; addable to track service coverage.</td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <input type="checkbox" (change)="updateMasterCheckbox()" [ngModelOptions]="{standalone: true}" [(ngModel)]="purchase">
                                                    {{ 'object-template.purchase' | translate }}
                                                </td>
                                                <td style="text-align: end;">The date/details of buying the asset; addable for lifecycle management.</td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <input type="checkbox" (change)="updateMasterCheckbox()" [ngModelOptions]="{standalone: true}" [(ngModel)]="parentAssetIdFlag">
                                                    {{ 'object-template.parentAssetIdFlag' | translate }}
                                                </td>
                                                <td style="text-align: end;">The main asset this item is linked to; addable for hierarchy tracking.</td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <input type="checkbox" (change)="updateMasterCheckbox()" [ngModelOptions]="{standalone: true}" [(ngModel)]="quantity">
                                                    {{ 'object-template.quantity' | translate }}
                                                </td>
                                                <td style="text-align: end;">The number of identical items; addable to avoid duplicate entries.</td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <input type="checkbox" (change)="updateMasterCheckbox()" [ngModelOptions]="{standalone: true}" [(ngModel)]="deploy">
                                                    {{ 'object-template.deploy' | translate }}
                                                </td>
                                                <td style="text-align: end;">Deployment related details; addable for the assets that are deployable</td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </div> -->





                                <div class="status-table">
                                    <table class="status-table__table">
                                        <thead>
                                            <tr>
                                                <th class="name-col">
                                                    <input type="checkbox" (click)="allCheck($event)"
                                                        [(ngModel)]="isAllChecked"
                                                        [ngModelOptions]="{ standalone: true }" />
                                                    Name
                                                </th>
                                                <th class="desc-col">Description</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            <tr>
                                                <td>
                                                    <input type="checkbox" [(ngModel)]="branch"
                                                        (change)="updateMasterCheckbox()"
                                                        [ngModelOptions]="{ standalone: true }" />
                                                    {{ 'object-template.branch' | translate }}
                                                </td>
                                                <td class="desc-col">
                                                    The office/division where the asset belongs; can be added to
                                                    identify ownership.
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <input type="checkbox" [(ngModel)]="department"
                                                        (change)="updateMasterCheckbox()"
                                                        [ngModelOptions]="{ standalone: true }" />
                                                    {{ 'object-template.department' | translate }}
                                                </td>
                                                <td class="desc-col">
                                                    The team or function using the asset; addable for tracking usage.
                                                </td>
                                            </tr>

                                            <!-- <tr>
                                                <td>
                                                    <input type="checkbox" [(ngModel)]="location"
                                                        (change)="updateMasterCheckbox()"
                                                        [ngModelOptions]="{ standalone: true }" />
                                                    {{ 'object-template.location' | translate }}
                                                </td>
                                                <td class="desc-col">
                                                    The physical place where the asset is kept; must be added for easy
                                                    identification.
                                                </td>
                                            </tr> -->

                                            <tr>
                                                <td>
                                                    <input type="checkbox" [(ngModel)]="make"
                                                        (change)="updateMasterCheckbox()"
                                                        [ngModelOptions]="{ standalone: true }" />
                                                    {{ 'object-template.make' | translate }}
                                                </td>
                                                <td class="desc-col">
                                                    The manufacturer or brand of the asset; addable to know who produced
                                                    it.
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <input type="checkbox" [(ngModel)]="model"
                                                        (change)="updateMasterCheckbox()"
                                                        [ngModelOptions]="{ standalone: true }" />
                                                    {{ 'object-template.model' | translate }}
                                                </td>
                                                <td class="desc-col">
                                                    The version or design name of the asset; addable to distinguish
                                                    similar items.
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <input type="checkbox" [(ngModel)]="serialNumber"
                                                        (change)="updateMasterCheckbox()"
                                                        [ngModelOptions]="{ standalone: true }" />
                                                    {{ 'object-template.serialNumber' | translate }}
                                                </td>
                                                <td class="desc-col">
                                                    The unique code given by the manufacturer; must be added to uniquely
                                                    identify the asset.
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <input type="checkbox" [(ngModel)]="originalCost"
                                                        (change)="updateMasterCheckbox()"
                                                        [ngModelOptions]="{ standalone: true }" />
                                                    {{ 'object-template.originalCost' | translate }}
                                                </td>
                                                <td class="desc-col">
                                                    The price paid when the asset was first purchased; addable for
                                                    financial records.
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <input type="checkbox" [(ngModel)]="currentCost"
                                                        (change)="updateMasterCheckbox()"
                                                        [ngModelOptions]="{ standalone: true }" />
                                                    {{ 'object-template.currentCost' | translate }}
                                                </td>
                                                <td class="desc-col">
                                                    The present value of the asset; addable to reflect today’s worth.
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <input type="checkbox" [(ngModel)]="depreciationRequired"
                                                        (change)="updateMasterCheckbox()"
                                                        [ngModelOptions]="{ standalone: true }" />
                                                    {{ 'object-template.depreciationRequired' | translate }}
                                                </td>
                                                <td class="desc-col">
                                                    The reduction in value over time; addable to calculate financial
                                                    reporting.
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <input type="checkbox" [(ngModel)]="warranty"
                                                        (change)="updateMasterCheckbox()"
                                                        [ngModelOptions]="{ standalone: true }" />
                                                    {{ 'object-template.warranty' | translate }}
                                                </td>
                                                <td class="desc-col">
                                                    The validity period of manufacturer support; addable to track
                                                    service coverage.
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <input type="checkbox" [(ngModel)]="purchase"
                                                        (change)="updateMasterCheckbox()"
                                                        [ngModelOptions]="{ standalone: true }" />
                                                    {{ 'object-template.purchase' | translate }}
                                                </td>
                                                <td class="desc-col">
                                                    The date/details of buying the asset; addable for lifecycle
                                                    management.
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <input type="checkbox" [(ngModel)]="parentAssetIdFlag"
                                                        (change)="updateMasterCheckbox()"
                                                        [ngModelOptions]="{ standalone: true }" />
                                                    {{ 'object-template.parentAssetIdFlag' | translate }}
                                                </td>
                                                <td class="desc-col">
                                                    The main asset this item is linked to; addable for hierarchy
                                                    tracking.
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <input type="checkbox" [(ngModel)]="quantity"
                                                        (change)="updateMasterCheckbox()"
                                                        [ngModelOptions]="{ standalone: true }" />
                                                    {{ 'object-template.quantity' | translate }}
                                                </td>
                                                <td class="desc-col">
                                                    The number of identical items; addable to avoid duplicate entries.
                                                </td>
                                            </tr>

                                            <tr *ngIf="quantity">
                                                <td>
                                                    <label style="margin: 0; padding-left: 20px;">UOM <span
                                                            class="required">*</span></label>
                                                </td>
                                                <td class="desc-col">
                                                    <select class="form-control" [(ngModel)]="uomName"
                                                        [ngModelOptions]="{standalone: true}">
                                                        <option value="" selected disabled> -- Select UOM --</option>
                                                        <option value="{{uomItem.uomName}}"
                                                            *ngFor="let uomItem of uomData;let i = index">
                                                            {{uomItem.uomName}}</option>
                                                    </select>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <input type="checkbox" [(ngModel)]="deploy"
                                                        (change)="updateMasterCheckbox()"
                                                        [ngModelOptions]="{ standalone: true }" />
                                                    {{ 'object-template.deploy' | translate }}
                                                </td>
                                                <td class="desc-col">
                                                    Deployment related details; addable for the assets that are
                                                    deployable.
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>




                            </div>


                            <!-- <div class="col-md-12 col-lg-12">
                                <div class="check-box-block">
                                    <div class="check-box-list">

                                        <div class="list">
                                            <p class="check-box">
                                                <input type="checkbox" [ngModelOptions]="{standalone: true}" [(ngModel)]="branch">
                                                {{ 'object-template.branch' | translate }}
                                            </p>
                                            <p class="check-desc">
                                                Description for branch.
                                            </p>
                                        </div>

                                        <div class="list">
                                            <p class="check-box">
                                                <input type="checkbox" [ngModelOptions]="{standalone: true}" [(ngModel)]="department">
                                                {{ 'object-template.department' | translate }}
                                            </p>
                                            <p class="check-desc">
                                                Description for department.
                                            </p>
                                        </div>

                                        <div class="list">
                                            <p class="check-box">
                                                <input type="checkbox" [ngModelOptions]="{standalone: true}" [(ngModel)]="location">
                                                {{ 'object-template.location' | translate }}
                                            </p>
                                            <p class="check-desc">
                                                Description for location.
                                            </p>
                                        </div>

                                        <div class="list">
                                            <p class="check-box">
                                                <input type="checkbox" [ngModelOptions]="{standalone: true}" [(ngModel)]="make">
                                                {{ 'object-template.make' | translate }}
                                            </p>
                                            <p class="check-desc">
                                                Description for make.
                                            </p>
                                        </div>

                                        <div class="list">
                                            <p class="check-box">
                                                <input type="checkbox" [ngModelOptions]="{standalone: true}" [(ngModel)]="model">
                                                {{ 'object-template.model' | translate }}
                                            </p>
                                            <p class="check-desc">
                                                Description for model.
                                            </p>
                                        </div>

                                        <div class="list">
                                            <p class="check-box">
                                                <input type="checkbox" [ngModelOptions]="{standalone: true}" [(ngModel)]="serialNumber">
                                                {{ 'object-template.serialNumber' | translate }}
                                            </p>
                                            <p class="check-desc">
                                                Description for serial number.
                                            </p>
                                        </div>

                                        <div class="list">
                                            <p class="check-box">
                                                <input type="checkbox" [ngModelOptions]="{standalone: true}" [(ngModel)]="originalCost">
                                                {{ 'object-template.originalCost' | translate }}
                                            </p>
                                            <p class="check-desc">
                                                Description for original cost.
                                            </p>
                                        </div>

                                        <div class="list">
                                            <p class="check-box">
                                                <input type="checkbox" [ngModelOptions]="{standalone: true}" [(ngModel)]="currentCost">
                                                {{ 'object-template.currentCost' | translate }}
                                            </p>
                                            <p class="check-desc">
                                                Description for current cost.
                                            </p>
                                        </div>

                                        <div class="list">
                                            <p class="check-box">
                                                <input type="checkbox" [ngModelOptions]="{standalone: true}" [(ngModel)]="depreciationRequired">
                                                {{ 'object-template.depreciationRequired' | translate }}
                                            </p>
                                            <p class="check-desc">
                                                Description for depreciation.
                                            </p>
                                        </div>

                                        <div class="list">
                                            <p class="check-box">
                                                <input type="checkbox" [ngModelOptions]="{standalone: true}" [(ngModel)]="warranty">
                                                {{ 'object-template.warranty' | translate }}
                                            </p>
                                            <p class="check-desc">
                                                Description for warranty.
                                            </p>
                                        </div>

                                        <div class="list">
                                            <p class="check-box">
                                                <input type="checkbox" [ngModelOptions]="{standalone: true}" [(ngModel)]="purchase">
                                                {{ 'object-template.purchase' | translate }}
                                            </p>
                                            <p class="check-desc">
                                                Description for purchase.
                                            </p>
                                        </div>

                                        <div class="list">
                                            <p class="check-box">
                                                <input type="checkbox" [ngModelOptions]="{standalone: true}" [(ngModel)]="parentAssetIdFlag">
                                                {{ 'object-template.parentAssetIdFlag' | translate }}
                                            </p>
                                            <p class="check-desc">
                                                Description for parent asset.
                                            </p>
                                        </div>

                                        <div class="list">
                                            <p class="check-box">
                                                <input type="checkbox" [ngModelOptions]="{standalone: true}" [(ngModel)]="quantity">
                                                {{ 'object-template.quantity' | translate }}
                                            </p>
                                            <p class="check-desc">
                                                Description for quantity.
                                            </p>
                                        </div>

                                        <div class="list">
                                            <p class="check-box">
                                                <input type="checkbox" [ngModelOptions]="{standalone: true}" [(ngModel)]="deploy">
                                                {{ 'object-template.deploy' | translate }}
                                            </p>
                                            <p class="check-desc">
                                                Description for deploy.
                                            </p>
                                        </div>

                                    </div>
                                </div>
                            </div> -->

                            <div class="col-md-12 col-lg-12">
                                <div class="proof-block-list">
                                    <label>Icon: <span class="required">*</span></label>
                                    <div hidden="true">
                                        <input #iconUrl type="file" id="iconUrl" accept="image/*" hidden="true"
                                            (change)="onImageChange($event,'iconUrl','add')">
                                    </div>

                                    <button class="add-proof-btn" *ngIf="!objectForm.get('iconUrl').value"
                                        (click)="addImageButton('iconUrl')">Add</button>
                                    <div class="proof-image" *ngIf="objectForm.get('iconUrl').value">
                                        <img [src]="objectForm.get('iconUrl').value" alt="">
                                        <button (click)="removeIcon('iconUrl','add')">Remove</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="nameValue">
                        <div>
                            <h5 class="multi-title">{{ 'object-template.specifications' | translate }}</h5>

                            <div class="row keys-content" *ngFor="let object of keys;let i = index;let last = last">
                                <div class="col-md-1 col-lg-1 paramBtn" style="padding-left: 0;" *ngIf="last">
                                    <i class="bi bi-plus-circle" (click)="addNameValue()"></i>
                                    <i class="bi bi-dash-circle" *ngIf="i!=0" (click)="removeNameValue(i)"></i>
                                    <i class="bi bi-arrow-return-right" (click)="addSubkey(i)"></i>

                                </div>
                                <div class="col-md-1 col-lg-1 paramBtn1" style="padding-left: 0;" *ngIf="!last">
                                    <i class="bi bi-dash-circle" (click)="removeNameValue(i)"></i>
                                    <i class="bi bi-arrow-return-right" (click)="addSubkey(i)"></i>
                                </div>
                                <div class="col-md-11 col-lg-11 keysBlock">
                                    <div class="form-group" style="display: flex; gap: 10px;">
                                        <input [(ngModel)]="keys[i].key" [ngModelOptions]="{standalone: true}"
                                            placeholder="enter key" type="text" class="form-control">
                                        <input [(ngModel)]="keys[i].value" [ngModelOptions]="{standalone: true}"
                                            placeholder="enter value" type="text" class="form-control">
                                    </div>
                                    <div class="row subkeys"
                                        *ngFor="let keyValue of object.keyValue;let j = index;let subLast = last">
                                        <div>

                                            <div class="col-md-1 col-lg-1 paramBtn1 paramBtn2">
                                                <i class="bi bi-dash-circle" (click)="removeSubkey(i,j)"></i>
                                                <i class="bi bi-arrow-return-right" (click)="addSubkey2(i,j)"></i>

                                            </div>
                                            <div class="col-md-11 col-lg-11" style="padding-right: 0;padding-left: 0">
                                                <div class="form-group" style="display: flex; gap: 10px;">
                                                    <input [(ngModel)]="keys[i].keyValue[j].key"
                                                        [ngModelOptions]="{standalone: true}"
                                                        placeholder="enter sub key" type="text" class="form-control">
                                                    <input [(ngModel)]="keys[i].keyValue[j].value"
                                                        [ngModelOptions]="{standalone: true}" placeholder="enter value"
                                                        type="text" class="form-control">
                                                </div>


                                                <div class="row subkeys1"
                                                    *ngFor="let keyValue1 of keyValue.keyValue;let k = index;let subLast1 = last">
                                                    <div>

                                                        <div class="col-md-1 col-lg-1 paramBtn1 paramBtn2">
                                                            <i class="bi bi-dash-circle"
                                                                (click)="removeSubkey2(i,j,k)"></i>
                                                            <i class="bi bi-arrow-return-right"
                                                                (click)="addSubkey3(i,j,k)"></i>

                                                        </div>
                                                        <div class="col-md-11 col-lg-11"
                                                            style="padding-right: 0;padding-left: 0">
                                                            <div class="form-group" style="display: flex; gap: 10px;">
                                                                <input [(ngModel)]="keys[i].keyValue[j].keyValue[k].key"
                                                                    [ngModelOptions]="{standalone: true}"
                                                                    placeholder="enter sub key" type="text"
                                                                    class="form-control">
                                                                <input
                                                                    [(ngModel)]="keys[i].keyValue[j].keyValue[k].value"
                                                                    [ngModelOptions]="{standalone: true}"
                                                                    placeholder="enter value" type="text"
                                                                    class="form-control">
                                                            </div>


                                                            <div class="row subkeys1"
                                                                *ngFor="let keyValue2 of keyValue1.keyValue;let l = index;let subLast2 = last">
                                                                <div>

                                                                    <div class="col-md-1 col-lg-1 paramBtn1">
                                                                        <i class="bi bi-dash-circle"
                                                                            (click)="removeSubkey3(i,j,k,l)"></i>
                                                                    </div>
                                                                    <div class="col-md-11 col-lg-11"
                                                                        style="padding-right: 0;padding-left: 10px">
                                                                        <div class="form-group"
                                                                            style="display: flex; gap: 10px;">
                                                                            <input
                                                                                [(ngModel)]="keys[i].keyValue[j].keyValue[k].keyValue[l].key"
                                                                                [ngModelOptions]="{standalone: true}"
                                                                                placeholder="enter sub key" type="text"
                                                                                class="form-control">
                                                                            <input
                                                                                [(ngModel)]="keys[i].keyValue[j].keyValue[k].keyValue[l].value"
                                                                                [ngModelOptions]="{standalone: true}"
                                                                                placeholder="enter value" type="text"
                                                                                class="form-control">
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div >
                            <h5 class="multi-title">Performance</h5>
                            <div class="row keys-content" *ngFor="let object of performanceMatrix;let i = index;let last = last">
                                 <div class="col-md-1 col-lg-1 paramBtn" style="padding-left: 0;" *ngIf="last">
                                    <i class="bi bi-plus-circle" (click)="addPerformanceMatrix()"></i>
                                    <i class="bi bi-dash-circle" *ngIf="i!=0" (click)="removePerformanceMatrix(i)"></i>
                                    <i class="bi bi-arrow-return-right" (click)="addSubPerformanceMatrix(i)"></i>

                                </div>
                                <div class="col-md-1 col-lg-1 paramBtn1" style="padding-left: 0;" *ngIf="!last">
                                    <i class="bi bi-dash-circle" (click)="removePerformanceMatrix(i)"></i>
                                    <i class="bi bi-arrow-return-right" (click)="addSubPerformanceMatrix(i)"></i>
                                </div>
                                <div class="col-md-11 col-lg-11 keysBlock">
                                    <div class="form-group">
                                        <input [(ngModel)]="performanceMatrix[i].key" [ngModelOptions]="{standalone: true}" placeholder="enter key" type="text" class="form-control">
                                    </div>
                                    <div class="row subkeys" *ngFor="let keyValue of object.keyValue;let j = index;let subLast = last">
                                        <div>
                                        
                                            <div class="col-md-1 col-lg-1 paramBtn1 paramBtn2">
                                                <i class="bi bi-dash-circle" (click)="removeSubPerformanceMatrix(i,j)"></i>
                                                <i class="bi bi-arrow-return-right" (click)="addSubPerformanceMatrix2(i,j)"></i>

                                            </div>
                                            <div class="col-md-11 col-lg-11" style="padding-right: 0;padding-left: 0">
                                                <div class="form-group">
                                                    <input [(ngModel)]="performanceMatrix[i].keyValue[j].key" [ngModelOptions]="{standalone: true}" placeholder="enter sub key" type="text" class="form-control">
                                                </div>


                                                <div class="row subkeys1" *ngFor="let keyValue1 of keyValue.keyValue;let k = index;let subLast1 = last">
                                                    <div>
                                                
                                                        <div class="col-md-1 col-lg-1 paramBtn1 paramBtn2">
                                                            <i class="bi bi-dash-circle" (click)="removeSubPerformanceMatrix2(i,j,k)"></i>
                                                            <i class="bi bi-arrow-return-right" (click)="addSubPerformanceMatrix3(i,j,k)"></i>

                                                        </div>
                                                        <div class="col-md-11 col-lg-11" style="padding-right: 0;padding-left: 0">
                                                            <div class="form-group">
                                                                <input [(ngModel)]="performanceMatrix[i].keyValue[j].keyValue[k].key" [ngModelOptions]="{standalone: true}" placeholder="enter sub key" type="text" class="form-control">
                                                            </div>


                                                            <div class="row subkeys1" *ngFor="let keyValue2 of keyValue1.keyValue;let l = index;let subLast2 = last">
                                                                <div>
                                                              
                                                                    <div class="col-md-1 col-lg-1 paramBtn1">
                                                                        <i class="bi bi-dash-circle" (click)="removeSubPerformanceMatrix3(i,j,k,l)"></i>
                                                                    </div>
                                                                    <div class="col-md-11 col-lg-11" style="padding-right: 0;padding-left: 10px">
                                                                        <div class="form-group">
                                                                            <input [(ngModel)]="performanceMatrix[i].keyValue[j].keyValue[k].keyValue[l].key" [ngModelOptions]="{standalone: true}" placeholder="enter sub key" type="text" class="form-control">
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                             </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> -->





                        <div *ngIf="warranty">
                            <h5 class="multi-title">{{ 'object-template.warranty' | translate }}</h5>
                            <div class="row keys-content">
                                <div class="col-md-12 col-lg-12 keysBlock">
                                    <div class="form-group"
                                        *ngFor="let object of warrantyInfo;let i = index;let last = last">
                                        <input [(ngModel)]="object.key" readonly style="cursor: not-allowed;"
                                            [ngModelOptions]="{standalone: true}" placeholder="enter key" type="text"
                                            class="form-control">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="purchase">
                            <h5 class="multi-title">{{ 'object-template.purchase' | translate }}</h5>
                            <div class="row keys-content">
                                <div class="col-md-12 col-lg-12 keysBlock">
                                    <div class="form-group"
                                        *ngFor="let object of purchaseInfo;let i = index;let last = last">
                                        <input [(ngModel)]="object.key" readonly style="cursor: not-allowed;"
                                            [ngModelOptions]="{standalone: true}" placeholder="enter key" type="text"
                                            class="form-control">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" id="closeModalButton2" (click)="closeModal()" class="btn btn-secondary"
                        data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
                    <button type="button" (click)="addObjectTemplate()" class="btn btn-primary">{{ 'generic.add' |
                        translate }}</button>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="modal fade" id="viewRole" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">{{ 'object-template.headings.detail' | translate }}
                    <span class="excel" (click)="downloadExcel()">
                        <img src="assets/img/Microsoft_Excel-Logo.wine.svg" alt="">
                    </span>
                    <span data-dismiss="modal">
                        <i (click)="clearData()" class="bi bi-x-lg"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <div class="form-group" *ngFor="let template of singleTemplate">
                    <div class="row">
                        <div class="col-md-6 col-lg-6">
                            <label>{{ 'object-template.name' | translate }}</label>
                            <p>{{template.name}}</p>
                        </div>
                        <div class="col-md-6 col-lg-6">
                            <label>{{ 'object-template.type' | translate }}</label>
                            <p>{{template.type}}</p>
                        </div>

                        <div class="col-md-6 col-lg-6">
                            <label>{{ 'object-template.group' | translate }}</label>
                            <p>{{template.group}}</p>
                        </div>

                        <div class="col-md-6 col-lg-6">
                            <label>{{ 'object-template.branch' | translate }}</label>
                            <p>{{template.branch? 'Yes': 'No'}}</p>
                        </div>

                        <div class="col-md-6 col-lg-6">
                            <label>{{ 'object-template.department' | translate }}</label>
                            <p>{{template.department? 'Yes': 'No'}}</p>
                        </div>

                        <div class="col-md-6 col-lg-6">
                            <label>{{ 'object-template.location' | translate }}</label>
                            <p>{{template.location? 'Yes': 'No'}}</p>
                        </div>

                        <div class="col-md-6 col-lg-6">
                            <label>{{ 'object-template.make' | translate }}</label>
                            <p>{{template.make? 'Yes': 'No'}}</p>
                        </div>

                        <div class="col-md-6 col-lg-6">
                            <label>{{ 'object-template.model' | translate }}</label>
                            <p>{{template.model? 'Yes': 'No'}}</p>
                        </div>

                        <div class="col-md-6 col-lg-6">
                            <label>{{ 'object-template.originalCost' | translate }}</label>
                            <p>{{template.originalCost? 'Yes': 'No'}}</p>
                        </div>

                        <div class="col-md-6 col-lg-6">
                            <label>{{ 'object-template.currentCost' | translate }}</label>
                            <p>{{template.currentCost? 'Yes': 'No'}}</p>
                        </div>

                        <div class="col-md-6 col-lg-6">
                            <label>{{ 'object-template.serialNumber' | translate }}</label>
                            <p>{{template.serialNumber? 'Yes': 'No'}}</p>
                        </div>

                        <div class="col-md-6 col-lg-6">
                            <label>{{ 'object-template.depreciationRequired' | translate }}</label>
                            <p>{{template.depreciationRequired? 'Yes': 'No'}}</p>
                        </div>

                        <div class="col-md-6 col-lg-6">
                            <label>{{ 'object-template.parentAssetIdFlag' | translate }}</label>
                            <p>{{template.parentAssetIdFlag? 'Yes': 'No'}}</p>
                        </div>

                        <div class="col-md-6 col-lg-6">
                            <label>{{ 'object-template.warranty' | translate }}</label>
                            <p>{{template.warranty? 'Yes': 'No'}}</p>
                        </div>

                        <div class="col-md-6 col-lg-6">
                            <label>{{ 'object-template.deploy' | translate }}</label>
                            <p>{{template.deploy? 'Yes': 'No'}}</p>
                        </div>

                        <div class="col-md-6 col-lg-6">
                            <label>{{ 'object-template.quantity' | translate }}</label>
                            <p>{{template.quantity? 'Yes': 'No'}}</p>
                        </div>

                        <div class="col-md-6 col-lg-6">
                            <label>UOM</label>
                            <p>{{template.uOM? 'Yes': 'No'}}</p>
                        </div>

                        <div class="col-md-6 col-lg-6" *ngIf="template.uOM">
                            <label>UOM Name</label>
                            <p>{{template.uomName}}</p>
                        </div>

                        <!-- <div class="col-md-12 col-lg-12" *ngIf="template.iconUrl != null && template.iconUrl != ''">
                                <div class="proof-block-list">
                                    <label>Icon:</label>
                                    <div class="proof-image">
                                        <img [src]="template.iconUrl" alt="">
                                    </div>
                                </div>
                            </div> -->

                        <div class="col-md-12 col-lg-12">
                            <div class="proof-block-list">
                                <label>Icon:</label>
                                <div hidden="true">
                                    <input #iconUrlEdit type="file" id="iconUrlEdit" accept="image/*" hidden="true"
                                        (change)="onImageChangeEdit($event)">
                                </div>
                                <button class="add-proof-btn" *ngIf="template.iconUrl == null || template.iconUrl == ''"
                                    (click)="addImageButton('iconUrlEdit')">Add</button>
                                <div class="proof-image" *ngIf="template.iconUrl">
                                    <img [src]="template.iconUrl" alt="">
                                    <button (click)="removeIconEdit()">Remove</button>
                                </div>
                            </div>
                        </div>


                        <div class="col-md-12 col-lg-12" style="display: flex;justify-content:center;"
                            *ngIf="template.nameValue && template.nameValue != null && template.nameValue != undefined && template.nameValue.length != 0">
                            <label>{{ 'object-template.nameValue' | translate }}</label>
                        </div>

                        <div class="col-md-12 col-lg-12 data-list"
                            *ngIf="template.nameValue && template.nameValue != null && template.nameValue != undefined && template.nameValue.length != 0">
                            <div class="list-block">

                                <ul class="ui-tree">
                                    <ng-container *ngFor="let item of template.nameValue">
                                        <ng-container
                                            *ngTemplateOutlet="renderNode; context: { $implicit: item }"></ng-container>
                                    </ng-container>
                                </ul>

                                <ng-template #renderNode let-node>
                                    <li>
                                        <strong>{{ node.key }}:</strong> {{ node.value }}
                                        <ul *ngIf="node.keyValue && node.keyValue.length > 0">
                                            <ng-container *ngFor="let child of node.keyValue">
                                                <ng-container
                                                    *ngTemplateOutlet="renderNode; context: { $implicit: child }"></ng-container>
                                            </ng-container>
                                        </ul>
                                    </li>
                                </ng-template>
                            </div>
                        </div>

                        <div class="col-md-12 col-lg-12" style="display: flex;justify-content:center;"
                            *ngIf="template.performanceMatrix && template.performanceMatrix != null && template.performanceMatrix != undefined && template.performanceMatrix.length != 0">
                            <label>{{ 'object-template.performanceMatrix' | translate }}</label>
                        </div>

                        <div class="col-md-12 col-lg-12 data-list"
                            *ngIf="template.performanceMatrix && template.performanceMatrix != null && template.performanceMatrix != undefined && template.performanceMatrix.length != 0">
                            <div class="list-block">

                                <ul class="ui-tree">
                                    <ng-container *ngFor="let item of template.performanceMatrix">
                                        <ng-container
                                            *ngTemplateOutlet="renderNode; context: { $implicit: item }"></ng-container>
                                    </ng-container>
                                </ul>

                                <ng-template #renderNode let-node>
                                    <li>
                                        <strong>{{ node.key }}:</strong> {{ node.value }}
                                        <ul *ngIf="node.keyValue && node.keyValue.length > 0">
                                            <ng-container *ngFor="let child of node.keyValue">
                                                <ng-container
                                                    *ngTemplateOutlet="renderNode; context: { $implicit: child }"></ng-container>
                                            </ng-container>
                                        </ul>
                                    </li>
                                </ng-template>
                            </div>
                        </div>


                        <div class="col-md-12 col-lg-12" style="display: flex;justify-content:center;margin-top: 20px;"
                            *ngIf="template.warranty">
                            <label>{{ 'object-template.warranty' | translate }}</label>
                        </div>

                        <div class="col-md-12 col-lg-12 data-list"
                            *ngIf="template.warranty && template.warrantyInfo && template.warrantyInfo != null && template.warrantyInfo != undefined && template.warrantyInfo.length != 0">
                            <div class="list-block">
                                <ul class="ui-tree">
                                    <li *ngFor="let item of template.warrantyInfo">
                                        <strong>{{ item.key }}:</strong> {{ item.value }}
                                    </li>
                                </ul>
                            </div>
                        </div>


                        <div class="col-md-12 col-lg-12" style="display: flex;justify-content:center;margin-top: 20px"
                            *ngIf="template.purchase">
                            <label>{{ 'object-template.purchase' | translate }}</label>
                        </div>

                        <div class="col-md-12 col-lg-12 data-list"
                            *ngIf="template.purchase && template.purchaseInfo && template.purchaseInfo != null && template.purchaseInfo != undefined && template.purchaseInfo.length != 0">
                            <div class="list-block">
                                <ul class="ui-tree">
                                    <li *ngFor="let item of template.purchaseInfo">
                                        <strong>{{ item.key }}:</strong> {{ item.value }}
                                    </li>
                                </ul>
                            </div>
                        </div>



                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" (click)="clearData()" id="closeModalButton3" class="btn btn-secondary"
                        data-dismiss="modal">{{ 'generic.close' | translate }}</button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="deleteModalLabel">{{ 'generic.confirmation' | translate }}
                    <span data-dismiss="modal">
                        <i data-dismiss="modal" (click)="cancelModel()" class="bi bi-x-lg"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <p>{{ 'generic.deleteText' | translate }} <span class="delete-span">“{{recordName}}”</span>?</p>
                <div class="modal-footer">
                    <button type="button" id="closeModalButton1" (click)="cancelModel()" class="btn btn-secondary"
                        data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
                    <button type="button" class="btn btn-primary" (click)="deleteObjectTemplate()">{{ 'generic.delete' |
                        translate }}</button>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="modal fade" id="editModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Edit Template
                    <span data-dismiss="modal" (click)="closeModal()">
                        <i (click)="clearData()" class="bi bi-x-lg"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body">

                <div [formGroup]="editTemplateForm">
                    <div class="form-group common-fields">
                        <div class="row">
                            <div class="col-md-12 col-lg-12">
                                <label>Name <span class="required">*</span></label>
                                <input formControlName="name" type="text" class="form-control">
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <label>Group <span class="required">*</span></label>
                                <select class="form-control" formControlName="group">
                                    <option value="" selected disabled> -- Select Group --</option>
                                    <option value="{{object.groupName}}"
                                        *ngFor="let object of objectGroupData;let i = index">{{object.groupName}}
                                    </option>
                                </select>
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <label>Type <span class="required">*</span></label>
                                <select class="form-control" formControlName="type">
                                    <option value="" selected disabled> -- Select Type --</option>
                                    <option value="{{object.typeName}}"
                                        *ngFor="let object of objectTypeData;let i = index">{{object.typeName}}</option>
                                </select>
                            </div>
                            <div class="col-md-12 col-lg-12 check-box">
                                <p><input type="checkbox" [ngModelOptions]="{standalone: true}" [checked]="branch"
                                        [(ngModel)]="branch"> Branch</p>
                                <p><input type="checkbox" [ngModelOptions]="{standalone: true}" [checked]="department"
                                        [(ngModel)]="department"> Department</p>
                                <p><input type="checkbox" [ngModelOptions]="{standalone: true}" [checked]="location"
                                        [(ngModel)]="location"> Location</p>
                                <p><input type="checkbox" [ngModelOptions]="{standalone: true}" [checked]="make"
                                        [(ngModel)]="make"> Make</p>
                                <p><input type="checkbox" [ngModelOptions]="{standalone: true}" [checked]="model"
                                        [(ngModel)]="model"> Model</p>
                                <p><input type="checkbox" [ngModelOptions]="{standalone: true}" [checked]="serialNumber"
                                        [(ngModel)]="serialNumber"> Serial Number</p>
                                <p><input type="checkbox" [ngModelOptions]="{standalone: true}" [checked]="originalCost"
                                        [(ngModel)]="originalCost"> Original Cost</p>
                                <p><input type="checkbox" [ngModelOptions]="{standalone: true}" [checked]="currentCost"
                                        [(ngModel)]="currentCost"> Current Cost</p>
                            </div>
                        </div>
                    </div>
                    <div class="nameValue">
                        <div>
                            <h5 class="multi-title">Specifications</h5>

                            <div class="row keys-content" *ngFor="let object of keys;let i = index;let last = last">
                                <div class="col-md-1 col-lg-1 paramBtn" style="padding-left: 0;" *ngIf="last">
                                    <i class="bi bi-plus-circle" (click)="addNameValue()"></i>
                                    <i class="bi bi-dash-circle" *ngIf="i!=0" (click)="removeNameValue(i)"></i>
                                    <i class="bi bi-arrow-return-right" (click)="addSubkey(i)"></i>

                                </div>
                                <div class="col-md-1 col-lg-1 paramBtn1" style="padding-left: 0;" *ngIf="!last">
                                    <i class="bi bi-dash-circle" (click)="removeNameValue(i)"></i>
                                    <i class="bi bi-arrow-return-right" (click)="addSubkey(i)"></i>
                                </div>
                                <div class="col-md-11 col-lg-11 keysBlock">
                                    <div class="form-group">
                                        <input [(ngModel)]="keys[i].key" [ngModelOptions]="{standalone: true}"
                                            placeholder="enter key" type="text" class="form-control">
                                    </div>
                                    <div class="row subkeys"
                                        *ngFor="let keyValue of object.keyValue;let j = index;let subLast = last">
                                        <div>
                                            <!-- <div class="col-md-1 col-lg-1 paramBtn" *ngIf="subLast">
                                                <i class="bi bi-plus-circle" (click)="addSubkey(i)"></i>
                                                <i class="bi bi-dash-circle" *ngIf="j!=0" (click)="removeSubkey(i,j)"></i>
                                            </div> -->
                                            <div class="col-md-1 col-lg-1 paramBtn1 paramBtn2">
                                                <i class="bi bi-dash-circle" (click)="removeSubkey(i,j)"></i>
                                                <i class="bi bi-arrow-return-right" (click)="addSubkey2(i,j)"></i>

                                            </div>
                                            <div class="col-md-11 col-lg-11" style="padding-right: 0;padding-left: 0">
                                                <div class="form-group">
                                                    <input [(ngModel)]="keys[i].keyValue[j].key"
                                                        [ngModelOptions]="{standalone: true}"
                                                        placeholder="enter sub key" type="text" class="form-control">
                                                </div>


                                                <div class="row subkeys1"
                                                    *ngFor="let keyValue1 of keyValue.keyValue;let k = index;let subLast1 = last">
                                                    <div>
                                                        <!-- <div class="col-md-1 col-lg-1 paramBtn" *ngIf="subLast1">
                                                            <i class="bi bi-plus-circle" (click)="addSubkey2(i,j)"></i>
                                                            <i class="bi bi-dash-circle" *ngIf="k!=0" (click)="removeSubkey2(i,j,k)"></i>
                                                        </div> -->
                                                        <div class="col-md-1 col-lg-1 paramBtn1 paramBtn2">
                                                            <i class="bi bi-dash-circle"
                                                                (click)="removeSubkey2(i,j,k)"></i>
                                                            <i class="bi bi-arrow-return-right"
                                                                (click)="addSubkey3(i,j,k)"></i>

                                                        </div>
                                                        <div class="col-md-11 col-lg-11"
                                                            style="padding-right: 0;padding-left: 0">
                                                            <div class="form-group">
                                                                <input [(ngModel)]="keys[i].keyValue[j].keyValue[k].key"
                                                                    [ngModelOptions]="{standalone: true}"
                                                                    placeholder="enter sub key" type="text"
                                                                    class="form-control">
                                                            </div>


                                                            <div class="row subkeys1"
                                                                *ngFor="let keyValue2 of keyValue1.keyValue;let l = index;let subLast2 = last">
                                                                <div>
                                                                    <!-- <div class="col-md-1 col-lg-1 paramBtn" *ngIf="subLast2">
                                                                        <i class="bi bi-plus-circle" (click)="addSubkey3(i,j,k)"></i>
                                                                        <i class="bi bi-dash-circle" *ngIf="l!=0" (click)="removeSubkey3(i,j,k,l)"></i>
                                                                    </div> -->
                                                                    <div class="col-md-1 col-lg-1 paramBtn1">
                                                                        <i class="bi bi-dash-circle"
                                                                            (click)="removeSubkey3(i,j,k,l)"></i>
                                                                    </div>
                                                                    <div class="col-md-11 col-lg-11"
                                                                        style="padding-right: 0;padding-left: 10px">
                                                                        <div class="form-group">
                                                                            <input
                                                                                [(ngModel)]="keys[i].keyValue[j].keyValue[k].keyValue[l].key"
                                                                                [ngModelOptions]="{standalone: true}"
                                                                                placeholder="enter sub key" type="text"
                                                                                class="form-control">
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div>
                            <h5 class="multi-title">Performance</h5>
                            <div class="row keys-content"
                                *ngFor="let object of performanceMatrix;let i = index;let last = last">
                                <div class="col-md-1 col-lg-1 paramBtn" style="padding-left: 0;" *ngIf="last">
                                    <i class="bi bi-plus-circle" (click)="addPerformanceMatrix()"></i>
                                    <i class="bi bi-dash-circle" *ngIf="i!=0" (click)="removePerformanceMatrix(i)"></i>
                                    <i class="bi bi-arrow-return-right" (click)="addSubPerformanceMatrix(i)"></i>

                                </div>
                                <div class="col-md-1 col-lg-1 paramBtn1" style="padding-left: 0;" *ngIf="!last">
                                    <i class="bi bi-dash-circle" (click)="removePerformanceMatrix(i)"></i>
                                    <i class="bi bi-arrow-return-right" (click)="addSubPerformanceMatrix(i)"></i>
                                </div>
                                <div class="col-md-11 col-lg-11 keysBlock">
                                    <div class="form-group">
                                        <input [(ngModel)]="performanceMatrix[i].key"
                                            [ngModelOptions]="{standalone: true}" placeholder="enter key" type="text"
                                            class="form-control">
                                    </div>
                                    <div class="row subkeys"
                                        *ngFor="let keyValue of object.keyValue;let j = index;let subLast = last">
                                        <div>
                                            <!-- <div class="col-md-1 col-lg-1 paramBtn" *ngIf="subLast">
                                                <i class="bi bi-plus-circle" (click)="addSubkey(i)"></i>
                                                <i class="bi bi-dash-circle" *ngIf="j!=0" (click)="removeSubkey(i,j)"></i>
                                            </div> -->
                                            <div class="col-md-1 col-lg-1 paramBtn1 paramBtn2">
                                                <i class="bi bi-dash-circle"
                                                    (click)="removeSubPerformanceMatrix(i,j)"></i>
                                                <i class="bi bi-arrow-return-right"
                                                    (click)="addSubPerformanceMatrix2(i,j)"></i>

                                            </div>
                                            <div class="col-md-11 col-lg-11" style="padding-right: 0;padding-left: 0">
                                                <div class="form-group">
                                                    <input [(ngModel)]="performanceMatrix[i].keyValue[j].key"
                                                        [ngModelOptions]="{standalone: true}"
                                                        placeholder="enter sub key" type="text" class="form-control">
                                                </div>


                                                <div class="row subkeys1"
                                                    *ngFor="let keyValue1 of keyValue.keyValue;let k = index;let subLast1 = last">
                                                    <div>
                                                        <!-- <div class="col-md-1 col-lg-1 paramBtn" *ngIf="subLast1">
                                                            <i class="bi bi-plus-circle" (click)="addSubkey2(i,j)"></i>
                                                            <i class="bi bi-dash-circle" *ngIf="k!=0" (click)="removeSubkey2(i,j,k)"></i>
                                                        </div> -->
                                                        <div class="col-md-1 col-lg-1 paramBtn1 paramBtn2">
                                                            <i class="bi bi-dash-circle"
                                                                (click)="removeSubPerformanceMatrix2(i,j,k)"></i>
                                                            <i class="bi bi-arrow-return-right"
                                                                (click)="addSubPerformanceMatrix3(i,j,k)"></i>

                                                        </div>
                                                        <div class="col-md-11 col-lg-11"
                                                            style="padding-right: 0;padding-left: 0">
                                                            <div class="form-group">
                                                                <input
                                                                    [(ngModel)]="performanceMatrix[i].keyValue[j].keyValue[k].key"
                                                                    [ngModelOptions]="{standalone: true}"
                                                                    placeholder="enter sub key" type="text"
                                                                    class="form-control">
                                                            </div>


                                                            <div class="row subkeys1"
                                                                *ngFor="let keyValue2 of keyValue1.keyValue;let l = index;let subLast2 = last">
                                                                <div>
                                                                    <!-- <div class="col-md-1 col-lg-1 paramBtn" *ngIf="subLast2">
                                                                        <i class="bi bi-plus-circle" (click)="addSubkey3(i,j,k)"></i>
                                                                        <i class="bi bi-dash-circle" *ngIf="l!=0" (click)="removeSubkey3(i,j,k,l)"></i>
                                                                    </div> -->
                                                                    <div class="col-md-1 col-lg-1 paramBtn1">
                                                                        <i class="bi bi-dash-circle"
                                                                            (click)="removeSubPerformanceMatrix3(i,j,k,l)"></i>
                                                                    </div>
                                                                    <div class="col-md-11 col-lg-11"
                                                                        style="padding-right: 0;padding-left: 10px">
                                                                        <div class="form-group">
                                                                            <input
                                                                                [(ngModel)]="performanceMatrix[i].keyValue[j].keyValue[k].keyValue[l].key"
                                                                                [ngModelOptions]="{standalone: true}"
                                                                                placeholder="enter sub key" type="text"
                                                                                class="form-control">
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" id="closeModalButtonEdit" (click)="closeModal()" class="btn btn-secondary"
                        data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
                    <button type="button" (click)="updateObjectTemplate()" class="btn btn-primary">{{ 'generic.update' |
                        translate }}</button>
                </div>
            </div>
        </div>
    </div>
</div>